import { Questionnaire, QuestionnaireRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createQuestionnaire: (
  fetchContext: FetchContext,
  winnerId: number, 
  questionnaire: Questionnaire,
  accessToken?: string,
) => Promise<QuestionnaireRef> = async (fetchContext, winnerId, questionnaire, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/winners/${winnerId}/questionnaires`, {
    method: 'POST',
    body: JSON.stringify(questionnaire),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<QuestionnaireRef>(fetchContext.errorStore, response, 'create questionnaire'));
};
